import apiClient from "./apiClient";

export const createDriverPaySlab = async (data) => {
  const response = await apiClient.post("/driver-pay-slabs/add", data);
  return response.data;
};

export const getAllDriverPaySlabs = async (params = {}) => {
  const response = await apiClient.get("/driver-pay-slabs/getall", { params });
  return response.data;
};

export const getDriverPaySlabById = async (id) => {
  const response = await apiClient.get(`/driver-pay-slabs/get/${id}`);
  return response.data;
};

export const updateDriverPaySlab = async (id, data) => {
  const response = await apiClient.put(`/driver-pay-slabs/update/${id}`, data);
  return response.data;
};

export const deleteDriverPaySlab = async (id) => {
  const response = await apiClient.delete(`/driver-pay-slabs/delete/${id}`);
  return response.data;
};

const driverPaySlabApi = {
  createDriverPaySlab,
  getAllDriverPaySlabs,
  getDriverPaySlabById,
  updateDriverPaySlab,
  deleteDriverPaySlab,
};

export default driverPaySlabApi;
